package com.evoapps.evoshift.domain.usecase.roster

import com.evoapps.evoshift.domain.model.Shift
import com.evoapps.evoshift.domain.repository.ShiftRepository
import com.evoapps.evoshift.domain.repository.UserRepository
import com.evoapps.evoshift.domain.model.RosterIds
import com.evoapps.evoshift.domain.usecase.user.ResolvePersonNamesUseCase
import kotlinx.coroutines.flow.Flow

class GetRosterShiftsUseCase(
    private val shiftRepository: ShiftRepository,
    private val userRepository: UserRepository
) {
    private val resolveNames = ResolvePersonNamesUseCase(userRepository)

    /**
     * The roster's shifts named after their people (SH-235: the shared resolver, the workplace's
     * team first, then the profiles of anyone else on the month).
     */
    suspend operator fun invoke(rosterId: String): Result<List<Shift>> =
        shiftRepository.getShiftsForRoster(rosterId).map { shifts ->
            val names = resolveNames(RosterIds.workplaceIdOf(rosterId), resolveNames.peopleOn(shifts))
            shifts.map { shift -> shift.copy(userDisplayName = shift.userId?.let(names::get)) }
        }

    /**
     * The roster's shifts as they change, without the profile reads: the caller names them from the
     * team it already has. Firestore shows this device's writes at once (before the server confirms).
     */
    fun observe(rosterId: String): Flow<List<Shift>> = shiftRepository.observeShiftsForRoster(rosterId)

    /** SH-263: the month's published shifts deleted since its last publish (owners and managers). */
    fun observeRemoved(rosterId: String): Flow<List<com.evoapps.evoshift.domain.model.RemovedShift>> =
        shiftRepository.observeRemovedShifts(rosterId)
}
